import React, { useState } from 'react';
import { User, Check, AlertCircle } from 'lucide-react';
import './NicknameSetup.css';

const NicknameSetup = ({ user, onNicknameSet, isOpen, onClose }) => {
  const [nickname, setNickname] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (nickname.trim().length < 2) {
      setError('닉네임은 2글자 이상이어야 합니다.');
      return;
    }

    if (nickname.trim().length > 20) {
      setError('닉네임은 20글자 이하여야 합니다.');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      // MariaDB에 닉네임 저장
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL || 'http://localhost:3002'}/api/users/nickname`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          userInfo: {
            uid: user.uid,
            email: user.email,
            displayName: user.displayName,
            photoURL: user.photoURL,
            nickname: nickname.trim()
          }
        })
      });

      const data = await response.json();

      if (data.success) {
        // 성공 시 부모 컴포넌트에 알림
        await onNicknameSet(nickname.trim());
      } else {
        throw new Error(data.error || '닉네임 저장에 실패했습니다.');
      }
    } catch (error) {
      setError(error.message || '닉네임 설정 중 오류가 발생했습니다.');
      console.error('Nickname setup error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="nickname-backdrop" onClick={onClose}></div>
      <div className="nickname-popup">
        <div className="nickname-container">
          {/* Header */}
          <div className="nickname-header">
            <div className="nickname-avatar">
              <User className="w-8 h-8 text-blue-600" />
            </div>
            <h2 className="nickname-title">닉네임 설정</h2>
            <p className="nickname-subtitle">
              채팅에 사용할 닉네임을 설정해주세요
            </p>
          </div>

          {/* User Info */}
          <div className="nickname-user-info">
            <img 
              src={user?.photoURL} 
              alt="프로필" 
              className="nickname-user-photo"
            />
            <div>
              <p className="nickname-user-name">{user?.displayName}</p>
              <p className="nickname-user-email">{user?.email}</p>
            </div>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="nickname-form">
            <div className="nickname-input-group">
              <label htmlFor="nickname" className="nickname-label">
                닉네임
              </label>
              <input
                type="text"
                id="nickname"
                value={nickname}
                onChange={(e) => setNickname(e.target.value)}
                placeholder="닉네임을 입력하세요"
                className="nickname-input"
                maxLength="20"
                disabled={isLoading}
              />
              <div className="nickname-help">
                2-20글자, 모든 문자 사용 가능
              </div>
            </div>

            {error && (
              <div className="nickname-error">
                <AlertCircle className="w-4 h-4" />
                <span>{error}</span>
              </div>
            )}

            <div className="nickname-actions">
              <button
                type="button"
                onClick={onClose}
                className="nickname-btn-cancel"
                disabled={isLoading}
              >
                취소
              </button>
              <button
                type="submit"
                className="nickname-btn-submit"
                disabled={isLoading || nickname.trim().length < 2}
              >
                {isLoading ? (
                  <div className="nickname-loading">설정 중...</div>
                ) : (
                  <div style={{width: '80px'}}> 
                    <span>완료</span>
                  </div>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default NicknameSetup;